<template>
  <div class="list-multi-form">
    <div class="group">
      <label>{{title}}</label>
      <div>
        <select v-model="selectedIndex">
          <option :value="null">{{noSelectionText}}</option>
          <option :value="i" v-for="(v,i) of value" :key="`${uniqueId}_${i}`">{{$to(v[labelKey]) || v[labelKey]}}</option>
        </select>
        <button class="btn btn-primary btn-add" @click="add">+</button>
        <button class="btn btn-primary btn-add" @click="remove" :disabled="!hasSelection">-</button>
      </div>
    </div>

    <div v-if="hasSelection" class="separator"></div>

    <component
      :is="formComponent"
      v-if="hasSelection"
      v-model="value[selectedIndex]"
      v-bind="formProps"
    />
  </div>
</template>

<script>
export default {
  name: "ListMultiForm",
  props: {
    value: {
      type: Array,
      required: true
    },
    formComponent: {
      type: Object,
      required: true
    },
    formProps: {
      type: Object,
      required: false,
      default: () => ({})
    },
    dataOnAdd: {
      Type: Object|Function,
      required: false,
    },
    title: {
      type: String,
      required: false
    },
    noSelectionText: {
      type: String,
      required: false
    },
    labelKey: {
      type: String,
      required: false,
      default: 'name'
    }
  },

  data() {
    return {
      selectedIndex: null,
      uniqueId: null,
    }
  },

  computed: {
    hasSelection() {
      return this.selectedIndex !== null;
    }
  },

  mounted() {
    this.uniqueId = Math.random().toString(36).substring(2)
  },

  methods: {
    add() {
      let newInstanceData = {};

      /* Check for initial data in form component */
      let inComponentMethodForNewInstance = this.formComponent.methods ? this.formComponent.methods.newElementData : undefined;
      if (typeof inComponentMethodForNewInstance === 'function') {
        Object.assign(newInstanceData, inComponentMethodForNewInstance());
      }

      /* Check for initial data passed by props */
      if (typeof this.dataOnAdd === 'function') {
        Object.assign(newInstanceData, this.dataOnAdd(this.value.length));
      } else if (typeof this.dataOnAdd === 'object' && this.dataOnAdd !== null) {
        Object.assign(newInstanceData, JSON.parse(JSON.stringify(this.dataOnAdd)));
      }

      this.value.push(newInstanceData);
      this.selectedIndex = this.value.length-1;
    },
    remove() {
      if (!this.hasSelection) { return; }
      this.value.splice(this.selectedIndex, 1);
      this.selectedIndex = this.value.length ? 0 : null;
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-add {
  margin-left: 10px;
}
.separator {
  margin: 40px;
  border: 1px dashed var(--primary-color)
}
</style>